import React, { PropsWithChildren, useEffect, useState } from 'react';
import { FloatingModalContainer, FloatingModalContainerProps } from './FloatingModalContainer';
import { FloatingModalContent, FloatingModalContentProps } from './FloatingModalContent';

export interface FloatingModalProps extends FloatingModalContentProps, Omit<FloatingModalContainerProps, 'setOpened'> {
  open: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

export const FloatingModal = ({
  shouldCloseOnOutsideClick = false,
  shouldCloseOnEscapeKey = false,
  openerTriggerEvent = 'click',
  trigger,
  onClose,
  onOpen,
  ...props
}: PropsWithChildren<FloatingModalProps>) => {
  const [opened, setOpened] = useState(Boolean(props.open));

  useEffect(() => {
    if (props.open !== undefined) {
      setOpened(props.open);
      props.open ? onOpen?.() : onClose?.();
    }
  }, [props.open]);

  useEffect(() => {
    opened ? onOpen?.() : onClose?.();
  }, [opened]);

  return (
    <FloatingModalContainer
      position={props.position}
      shouldCloseOnEscapeKey={shouldCloseOnEscapeKey}
      shouldCloseOnOutsideClick={shouldCloseOnOutsideClick}
      openerTriggerEvent={openerTriggerEvent}
      trigger={trigger}
      setOpened={setOpened}
      open={opened}
    >
      <FloatingModalContent
        {...props}
        open={opened}
        onCancel={() => {
          setOpened(false);
          onClose?.();
        }}
      />
    </FloatingModalContainer>
  );
};
